export enum ChangeCashMode {
  Deposit = 'deposit',
  Withdraw = 'withdraw',
  Adjust = 'adjust',
  Transfer = 'transfer',
}

export interface CashState {
  [factor: number]: number;
}
